import {
    MoneyMapStatus,
    type MoneyMapWithRulesAndAccounts,
} from '@fruitful/types';
import { orderBy } from 'lodash';

import { buildQueryParams } from '../../common/misc';
import { requestBuilder } from '../../http/RequestBuilder';
import { captureDebug } from '../../logger/Logger';

export const useGetMoneyMapsForMembership = requestBuilder.query<
    MoneyMapWithRulesAndAccounts[],
    {
        status?: MoneyMapStatus[];
    }
>({
    endpoint: (query) => `/api/money-map/${buildQueryParams(query)}`,
    queryKey: (query) => `getMoneyMapsForMembership/${buildQueryParams(query)}`,
});

export const useGetMoneyMapForMembership = () => {
    const { data, isLoading, ...rest } = useGetMoneyMapsForMembership({
        status: [MoneyMapStatus.PREVIEW, MoneyMapStatus.ACTIVE],
    });

    let moneyMap: MoneyMapWithRulesAndAccounts | undefined;
    if (!isLoading && data != null) {
        if (data?.length != null && data.length > 1) {
            captureDebug(
                'Multiple money maps exist with active and preview statuses, defaulting to most recently updated map',
            );
        }
        moneyMap = orderBy(data, 'updatedAt', 'desc')[0];
    }

    return {
        data: moneyMap,
        isLoading,
        ...rest,
    };
};
